import { EditorSidebarProvider } from '@src/context/EditorSidebarContext';
import TenantNavBar from '@src/ui/templates/Tenant/Header/TenantNavBar';
import React from 'react';

type Props = {
  children: React.ReactNode;
};

function TenantWithoutSideBarLayout({ children }: Props) {
  return (
    <div className='flex min-h-screen flex-col'>
      <div className='flex flex-1 flex-col'>
        <TenantNavBar hideSidebarToggleMenu />
        <EditorSidebarProvider initialOpen={true}>{children}</EditorSidebarProvider>
      </div>
    </div>
  );
}

export default TenantWithoutSideBarLayout;
